export default "__VITE_ASSET__1c663ce5__"